import { siteConfig } from './config/siteConfig';

// The production bundle is served on both ritabygglov.se and drawblueprint.com
// by the Express backend, which injects window.__SITE_CONFIG__ per request.
// When that's present, the API host must follow the domain the page was
// actually loaded from rather than the build-time env var, otherwise requests
// always hit ritabygglov.se and the backend resolves the wrong site/brand.
// Other environments (e2e, local dev, ngrok) serve the bundle without that
// injection and rely on the build-time env vars instead.
const hasInjectedSiteConfig = Boolean(window.__SITE_CONFIG__);

export const API_BASE_URL = hasInjectedSiteConfig
  ? `https://${siteConfig.domain}/api`
  : (import.meta.env.VITE_API_BASE_URL as string);
export const WS_URL = hasInjectedSiteConfig
  ? `wss://${siteConfig.domain}`
  : (import.meta.env.VITE_API_WS_URL as string);
